// src/features/streams/components/simulcast/DestinationEmptyState.tsx

import { Stack, Text, Button, Group } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { RtmpLogo, FacebookLogo, YouTubeLogo } from './PlatformLogos';

interface DestinationEmptyStateProps {
  onAdd: () => void;
}

export function DestinationEmptyState({ onAdd }: DestinationEmptyStateProps) {
  return (
    <Stack align="center" justify="center" py={60} gap="lg">
      <Group gap="lg">
        <RtmpLogo size={48} />
        <FacebookLogo size={48} />
        <YouTubeLogo size={48} />
      </Group>

      <Stack align="center" gap="xs">
        <Text fw={600} size="lg">No destinations configured</Text>
        <Text c="dimmed" size="sm" maw={400} ta="center">
          Stream to Facebook Live, YouTube Live, or any custom RTMP endpoint simultaneously.
        </Text>
      </Stack>

      <Button
        leftSection={<IconPlus size={16} />}
        onClick={onAdd}
      >
        Add Destination
      </Button>
    </Stack>
  );
}
